$(document).ready(function () { 
  var quickview = $('.quickview');

  // Formata preco em centavos usando o formato de moeda da loja.
  // Corrigido em 21/09/2026: o codigo antigo procurava o placeholder \{\{amount\}\},
  // mas a loja usa \{\{amount_with_comma_separator\}\}, entao o placeholder aparecia cru.
  function formatarPreco(centavos) {
    var simbolo = 'R$';
    try {
      if (typeof moneyFormat !== 'undefined' && moneyFormat) {
        simbolo = moneyFormat.replace(/\{\{[^}]*\}\}/g, '').trim() || 'R$';
      }
    } catch (e) {}
    var valor = (Number(centavos) / 100).toFixed(2).replace('.', ',');
    return simbolo + ' ' + valor;
  }

  var main_image=$('#productModal .modal-body .product-images .main-image img'),

      main_href=$('#productModal .modal-body .product-images .main-image a'),

      other_image=$('#productModal .modal-body .product-images .other-image  ul'),

      rating=$('#productModal .modal-body .product-desc .rating'),

      modal_title=$('#productModal .modal-body .product-info .quickview-title'),

      price=$('#productModal .modal-body .product-info .price-box .price'),

      modal_desc=$('#productModal .modal-body .product-info .quick-desc'),

      main_desc_href=$('#productModal .modal-body .product-info .see-all'),

      share=$('#productModal .modal-body .product-info .social-sharing'),

      btn_add=$('#productModal .modal-body .product-info .quick-add-to-cart .single_add_to_cart_button');

  field_add=$('#productModal .modal-body .product-info .quick-add-to-cart #id');

  btn_compare=$('#productModal .modal-body .product-info .button-group .btn-compare');

  btn_wishlist=$('#productModal .modal-body .product-info .button-group .btn-wishlist'); 		

  $('body').on('click', '.quickview', function (){
    other_image.empty();

    rating.empty();

    price.empty();

    var product_info=$(this).data('productinfo');		
    main_image.attr('src',product_info['images'][0]);

    main_href.attr('href','/products/'+product_info['handle']);

    main_desc_href.attr('href','/products/'+product_info['handle']);

    var arr_image=product_info['images'];

    for(var i=0;i<arr_image.length&&i<3;i++){ 			

      other_image.append('<li><img style="width:78px;cursor:pointer" class="img-thumbnail other-image" src="'+arr_image[i]+'"></li>')
    }

    $('.other-image').click(function(){
      main_image.attr('src',$(this).attr('src'));
    });

    modal_title.html(product_info['title']);

    var desc = product_info['description'];
    var res = desc.trim();
    modal_desc.html(res.substring(0, 150));
    rating.append('<span class="shopify-product-reviews-badge" data-id="'+ product_info["id"] +'"></span>');

    if(product_info['price']){
      if(product_info['compare_at_price'] && product_info['compare_at_price'] > product_info['price']){
        price.append('<span class="new-price">'+ formatarPreco(product_info['price']) +'</span><span class="old-price">'+ formatarPreco(product_info['compare_at_price']) +'</span>');
      }
      else{
        price.append('<span class="new-price">'+ formatarPreco(product_info['price']) +'</span>');
      }
    }

    $(field_add).val(product_info['variants'][0]['id']);

    btn_add.attr('href','/products/'+product_info['handle']); 		
    btn_compare.attr('onclick','compare.add('+product_info["product_id"]+')');
    btn_wishlist.attr('onclick','wishlish.add('+product_info["product_id"]+')');

  });
});